import './util/embeddedBundleSession'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import store, { persistor } from './store'
import { PersistGate } from 'redux-persist/integration/react'
import WebSocketProvider from './components/webSocketConnection/WebSocket'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './ErrorFallback'
import ThemeProvider from './theme/ThemeProvider'
import { BrowserRouter } from 'react-router-dom'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import ROUTES from './assets/routes'
import ShortcutsProvider from './components/KeyboardShortcuts/Shortcuts.context'
import EmbeddedWrapper from './embeddedWrapper'
import { isEmbeddedModeSet } from './util/general'
import SecurityManager from './util/securityManager'
import { UserProvider } from './context/UserContext'

const embeddedMode = isEmbeddedModeSet();
const routerBaseName = import.meta.env.BASE_URL === '/' ? undefined : import.meta.env.BASE_URL.replace(/\/$/, '')

const root = ReactDOM.createRoot(document.getElementById("root")!)

window.securityManager = new SecurityManager();

// Disable console logs in production only when deployed (not on localhost) - allows debugging locally
const isProductionDeployed = import.meta.env.MODE === "production" && !window.location.origin.includes("localhost");
const debugLogsEnabled = import.meta.env.VITE_DEBUG_LOGS === "true";
if (isProductionDeployed && !debugLogsEnabled) {
    console.log = () => {};
    console.debug = () => {};
    console.warn = () => {};
}

const app = (
    <WebSocketProvider>
        <ShortcutsProvider>
            <App key={'tick2trade'} />
        </ShortcutsProvider>
    </WebSocketProvider>
)

root.render(
    <Provider store={store}>
        <ThemeProvider>
            <UserProvider>
                <BrowserRouter basename={routerBaseName}>
                    <EmbeddedWrapper>
                        <ErrorBoundary
                            key={'app-fallback'}
                            FallbackComponent={ErrorFallback}
                            onReset={(reset) => {
                                //@ts-ignore
                                if (reset?.args?.[0]) {
                                    window.location.href = import.meta.env.BASE_URL
                                } else {
                                    window.location.reload()
                                }
                            }}
                        >
                            {embeddedMode ? app : (
                                <PersistGate loading={null} persistor={persistor}>
                                    {app}
                                </PersistGate>
                            )}
                        </ErrorBoundary>
                    </EmbeddedWrapper>
                </BrowserRouter>
            </UserProvider>
        </ThemeProvider>
    </Provider>
)

serviceWorkerRegistration.disableServiceWorker()